import React from 'react';

import { ButtonProps, ButtonWithForwardedRef } from '../button/Button';

import { ActionsMenuAsChildItem } from './items/ActionsMenuAsChildItem';

export const ActionsMenuActionLink = React.forwardRef<HTMLButtonElement, ButtonProps<{}>>(
  ({ variant = 'link', ...props }, ref) => {
    return (
      <ActionsMenuAsChildItem>
        <ButtonWithForwardedRef {...props} size="sm" variant={variant} ref={ref} />
      </ActionsMenuAsChildItem>
    );
  },
);

ActionsMenuActionLink.displayName = 'ActionsMenuActionLink';
